module.exports = __webpack_public_path__ + "1b2fb62f37f1c1e59208f4993714d166.svg";